export default {
	state: {
		dept:[],
		post:[],
		userId:'',
		userDesc:'',
		userName:''
	},

	mutations: {
	 
		setDept(state, dept) {
			state.dept = dept
		}
		,
		setPost(state, post) {
			state.post = post
		}
		,
		setUserDesc(state, userDesc) {
			state.userDesc = userDesc
		},
		setUserId(state, userId) {
			state.userId = userId
		},
		setUserName(state, userName) {
			state.userName = userName
		}
	},
	actions: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js